"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6288],{

/***/ 78516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Button_Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Button/Button.styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 6rem;\n  border-radius: ",
        "px;\n  outline: none;\n  border: none;\n  padding: 0.75rem 1rem;\n  cursor: pointer;\n  &.btn__primary {\n    background: ",
        ";\n    color: ",
        ";\n    font-size: ",
        "rem;\n    font-family: ",
        ";\n    font-weight: ",
        ";\n  }\n  &.btn__primary:hover {\n    background: ",
        ";\n    transition: background 0.5s ease-in-out;\n  }\n  &.btn__secondary {\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n    font-size: ",
        "rem;\n    font-family: ",
        ";\n    font-weight: ",
        ";\n  }\n  &.btn__secondary:hover {\n    background: ",
        ";\n    transition: background 0.5s ease-in-out;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ButtonComponent = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "ButtonComponent",
    componentId: "sc-7bbccc7b-0"
})(_templateObject(), function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.roundness) || 0;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.backgroundColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.color;
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.textFontSize) || 1;
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.fontFamily) || "Arial";
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.fontWeight) || "500";
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.backgroundHoverColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.backgroundColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.borderColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.borderColor;
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.textFontSize) || 1;
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.fontFamily) || "Arial";
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.fontWeight) || "500";
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.borderColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.color;
});

// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/btnUtils.js
var btnUtils = __webpack_require__(93080);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Button/Button.js



var Button = function(props) {
    var ref, ref1, ref2;
    return (props === null || props === void 0 ? void 0 : (ref = props.btnData) === null || ref === void 0 ? void 0 : ref.btnText) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonComponent, {
        className: "btn__".concat(props === null || props === void 0 ? void 0 : (ref1 = props.btnData) === null || ref1 === void 0 ? void 0 : ref1.type),
        primaryButton: props === null || props === void 0 ? void 0 : props.primaryButton,
        secondaryButton: props === null || props === void 0 ? void 0 : props.secondaryButton,
        onClick: function() {
            var ref;
            (0,btnUtils/* btnActionHandler */.c)(props === null || props === void 0 ? void 0 : (ref = props.btnData) === null || ref === void 0 ? void 0 : ref.actions, props === null || props === void 0 ? void 0 : props.callback);
            (props === null || props === void 0 ? void 0 : props.handleClose) && (props === null || props === void 0 ? void 0 : props.handleClose());
        },
        children: props === null || props === void 0 ? void 0 : (ref2 = props.btnData) === null || ref2 === void 0 ? void 0 : ref2.btnText
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var Button_Button = (Button);


/***/ }),

/***/ 58252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Description = function(props) {
    var ref;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        onClick: function(e) {
            var ref, ref1, ref2;
            e.stopPropagation();
            props === null || props === void 0 ? void 0 : (ref = props.handleEditText) === null || ref === void 0 ? void 0 : ref.call(props);
            props === null || props === void 0 ? void 0 : (ref2 = props.getInputPreFilledValue) === null || ref2 === void 0 ? void 0 : ref2.call(props, (ref1 = props.descriptionData) === null || ref1 === void 0 ? void 0 : ref1.text);
        },
        className: "Description",
        children: (ref = props.descriptionData) === null || ref === void 0 ? void 0 : ref.text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Description);


/***/ }),

/***/ 92578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Heading = function(props) {
    var ref;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        className: "Heading",
        children: props === null || props === void 0 ? void 0 : (ref = props.headingData) === null || ref === void 0 ? void 0 : ref.text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Heading);


/***/ }),

/***/ 86288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ModernMiddleBody3_ModernMiddleBody3; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Heading/Heading.js
var Heading = __webpack_require__(92578);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Description/Description.js
var Description = __webpack_require__(58252);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Button/Button.js + 1 modules
var Button = __webpack_require__(78516);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/common.ts
var common = __webpack_require__(37179);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/getStylesConfig.js
var getStylesConfig = __webpack_require__(42757);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/common.js + 9 modules
var utils_common = __webpack_require__(20901);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(26601);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/MiddleBody/MiddleBody_2_Column/ModernMiddleBody3/ModernMiddleBody3.styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  background-size: cover;\n  background-position: center;\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 0; /* Set the z-index behind other content */\n  }\n  /* Add a linear gradient overlay */\n  &::after {\n    content: '';\n    background: ",
        ";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    opacity: ",
        ";\n  }\n  @media screen and (min-width: 768px) {\n    & > video {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover; /* Scale the video while maintaining its aspect ratio */\n    }\n  }\n  @media screen and (max-width: 767px) {\n    & > video {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover; /* Scale the video while maintaining its aspect ratio */\n    }\n  }\n  & > video {\n    position: absolute;\n    height: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  z-index: 3;\n  &.bg_type_image {\n    background: ",
        ";\n    background-size: cover;\n    background-position: center;\n    & > .bg {\n      position: absolute;\n      height: 100%;\n      object-fit: cover;\n      width: 100%;\n    }\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      z-index: 0; /* Set the z-index behind other content */\n    }\n    /* Add a linear gradient overlay */\n    &::after {\n      content: '';\n      background: ",
        ";\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      opacity: ",
        ";\n      z-index: 1;\n    }\n  }\n\n  &.bg_type_solid {\n    background: ",
        ";\n  }\n  &.bg_type_image::after,\n  .bg_type_solid {\n    content: '';\n    background: ",
        ";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: ",
        ";\n    z-index: 1;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  z-index: 2;\n  gap: 4rem;\n  @media screen and (min-width: 768px) {\n    flex-direction: row;\n  }\n  @media screen and (max-width: 767px) {\n    flex-direction: column-reverse;\n    padding: 0 0 2rem 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 2.625rem;\n  align-self: center;\n  @media screen and (min-width: 768px) {\n    padding: 4rem 0 4rem 4rem;\n    width: 50%;\n  }\n  @media screen and (max-width: 767px) {\n    width: 100%;\n    padding: 0 1rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-self: stretch;\n  aspect-ratio: 1/1;\n  background-color: ",
        ";\n\n  & > .slider__parent,\n  & > .slider__parent > .slick-slider,\n  & > .slider__parent > .slick-slider > .slick-list,\n  & > .slider__parent > .slick-slider > .slick-list > .slick-track,\n  & > .slider__parent > .slick-slider > .slick-list > .slick-track > .slick-slide,\n  & > .slider__parent > .slick-slider > .slick-list > .slick-track > .slick-slide > div,\n  &\n    > .slider__parent\n    > .slick-slider\n    > .slick-list\n    > .slick-track\n    > .slick-slide\n    > div\n    > .slider-media,\n  &\n    > .slider__parent\n    > .slick-slider\n    > .slick-list\n    > .slick-track\n    > .slick-slide\n    > div\n    > .slider-media\n    > .slide-image-container,\n  &\n    > .slider__parent\n    > .slick-slider\n    > .slick-list\n    > .slick-track\n    > .slick-slide\n    > div\n    > .slider-media\n    > .slide-image-container\n    > img {\n    height: 100% !important;\n  }\n  & > .slider__parent > .slick-slider > .slick-dots {\n    display: none;\n  }\n  & > .slider__parent > .slick-slider > .slick-dots > .slick-active {\n    background-color: #000;\n    display: none;\n  }\n  @media screen and (min-width: 768px) {\n    width: 50%;\n    & > .slider__parent > .slick-slider > .slick-dots {\n      bottom: -1rem !important;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    width: 100%;\n    & > .slider__parent > .slick-slider > .slick-dots {\n      bottom: -0.625rem !important;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  align-self: flex-start;\n  width: 100%;\n  & > h1 {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    margin: 0;\n    color: ",
        ";\n    font-family: ",
        ";\n    text-align: ",
        ";\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  & > p {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    font-style: normal;\n    margin: 0;\n    color: ",
        ";\n    text-align: ",
        ";\n    font-family: ",
        ";\n    opacity: ",
        ";\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  @media screen and (min-width: 768px) {\n    gap: 1.5rem;\n    & > h1 {\n      font-size: ",
        ";\n      font-weight: ",
        ";\n      line-height: 3.875rem;\n      align-self: flex-start;\n      width: 100%;\n    }\n    & > p {\n      font-size: ",
        ";\n      font-weight: ",
        ";\n      line-height: 1.75rem;\n      align-self: flex-start;\n      width: 100%;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    gap: 0.75rem;\n    & > h1 {\n      font-size: 1.5rem;\n      font-weight: 700;\n      line-height: normal;\n      width: 100%;\n      align-self: center;\n    }\n    & > p {\n      font-size: 0.875rem;\n      font-weight: 400;\n      line-height: normal;\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  align-self: flex-start;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-start;\n  gap: 1rem;\n  flex-wrap: wrap;\n  @media screen and (max-width: 767px) {\n    flex-direction: column;\n    width: 100%;\n    button {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var MiddleBodyVideoBackground = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject(), function(props) {
    var ref, ref1;
    return !((ref1 = props === null || props === void 0 ? void 0 : (ref = props.propsBackground) === null || ref === void 0 ? void 0 : ref.content[0]) === null || ref1 === void 0 ? void 0 : ref1.url) && "none, ".concat(props === null || props === void 0 ? void 0 : props.themeBackground);
}, function(props) {
    return props === null || props === void 0 ? void 0 : props.themeBackground;
}, utils_common/* BANNER_OPACITY */.Gx);
var MiddleBodyParent = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1(), function(props) {
    var ref, ref1, ref2, ref3;
    return ((ref1 = props === null || props === void 0 ? void 0 : (ref = props.propsBackground) === null || ref === void 0 ? void 0 : ref.content[0]) === null || ref1 === void 0 ? void 0 : ref1.url) ? "url(".concat((ref3 = props === null || props === void 0 ? void 0 : (ref2 = props.propsBackground) === null || ref2 === void 0 ? void 0 : ref2.content[0]) === null || ref3 === void 0 ? void 0 : ref3.url, ")") : "none, ".concat(props === null || props === void 0 ? void 0 : props.themeBackground);
}, function(props) {
    return props === null || props === void 0 ? void 0 : props.themeBackground;
}, utils_common/* BANNER_OPACITY */.Gx, function(props) {
    return props === null || props === void 0 ? void 0 : props.themeBackground;
}, function(props) {
    return props === null || props === void 0 ? void 0 : props.themeBackground;
}, utils_common/* BANNER_OPACITY */.Gx);
var BannerContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject2());
var LeftContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3());
var RightContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject4(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.IS_MEDIA_URL) ? "transparent" : utils_common/* FALLBACK_COLOR */.R3;
});
var TopSection = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject5(), function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.textAlign) || "left";
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.textAlign) || "left";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, utils_common/* BODY_COLOR_OPACITY */.ur, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || "3.25rem";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "500";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || "1.25rem";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "400";
});
var BottomSection = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject6());
var ButtonContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject7());

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var actions_common = __webpack_require__(31024);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/MiddleBody/MiddleBody_2_Column/ModernMiddleBody3/ModernMiddleBody3.js












function ModernMiddleBody3(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24;
    var ref25 = (0,react.useState)((0,common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.children)), middleBodyState = ref25[0], setMiddleBodyState = ref25[1];
    var ref26 = (0,react.useState)({
        config: {
            bannerAspectRatio: {
                desktop: 768,
                mobile: 768
            },
            rotationSpeed: 3
        }
    }), styleConfig = ref26[0];
    var dispatch = (0,es/* useDispatch */.I0)();
    var openForm = function() {
        dispatch((0,actions_common/* toggleFormWidget */.Aq)(true));
    };
    (0,react.useEffect)(function() {
        var video = document.querySelector("video");
        if (video) {
            video.setAttribute("playsinline", "");
        }
    }, []);
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var widgetData = (0,es/* useSelector */.v9)(function(state) {
        return {
            widgetData: state.widgetsReducer
        };
    }).widgetData;
    var ref27 = (0,react.useState)(storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : ref1.style_template), propStyle = ref27[0], setPropStyle = ref27[1];
    (0,react.useEffect)(function() {
        var ref;
        if (props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.children) {
            var ref1;
            setMiddleBodyState((0,common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref1 = props.config) === null || ref1 === void 0 ? void 0 : ref1.children));
        }
    }, [
        props === null || props === void 0 ? void 0 : (ref2 = props.config) === null || ref2 === void 0 ? void 0 : ref2.children
    ]);
    (0,react.useEffect)(function() {
        if (widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate) {
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate));
        } else {
            var ref;
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.style_template));
        }
    }, [
        widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate,
        storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.theme) === null || ref3 === void 0 ? void 0 : ref3.style_template
    ]);
    var renderParentContainer = function(bgType) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                ((middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref = middleBodyState.heading) === null || ref === void 0 ? void 0 : ref.text) || (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref1 = middleBodyState.description) === null || ref1 === void 0 ? void 0 : ref1.text) || (middleBodyState === null || middleBodyState === void 0 ? void 0 : middleBodyState.button)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftContainer, {
                    children: [
                        ((middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref2 = middleBodyState.heading) === null || ref2 === void 0 ? void 0 : ref2.text) || (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref3 = middleBodyState.description) === null || ref3 === void 0 ? void 0 : ref3.text) || (middleBodyState === null || middleBodyState === void 0 ? void 0 : middleBodyState.buttons)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopSection, {
                            textStyles: propStyle,
                            children: [
                                (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref4 = middleBodyState.heading) === null || ref4 === void 0 ? void 0 : ref4.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    headingData: middleBodyState === null || middleBodyState === void 0 ? void 0 : middleBodyState.heading
                                }),
                                (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref5 = middleBodyState.description) === null || ref5 === void 0 ? void 0 : ref5.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                                    descriptionData: middleBodyState === null || middleBodyState === void 0 ? void 0 : middleBodyState.description
                                })
                            ]
                        }),
                        (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref6 = middleBodyState.button) === null || ref6 === void 0 ? void 0 : ref6.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSection, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonContainer, {
                                children: middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref7 = middleBodyState.button) === null || ref7 === void 0 ? void 0 : ref7.content.map(function(btnData, idx) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        btnData: btnData,
                                        primaryButton: propStyle === null || propStyle === void 0 ? void 0 : propStyle.buttonPrimary,
                                        secondaryButton: propStyle === null || propStyle === void 0 ? void 0 : propStyle.buttonSecondary,
                                        callback: openForm
                                    }, (btnData === null || btnData === void 0 ? void 0 : btnData.id) || idx);
                                })
                            })
                        })
                    ]
                }),
                (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref8 = middleBodyState.media) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.foreground) === null || ref9 === void 0 ? void 0 : ref9.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)(RightContainer, {
                    IS_MEDIA_URL: (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref10 = middleBodyState.media) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.foreground) === null || ref11 === void 0 ? void 0 : ref11.content.length) ? true : false,
                    children: (0,utils_common/* renderMediaComponent */.CB)(middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref12 = middleBodyState.media) === null || ref12 === void 0 ? void 0 : ref12.foreground)
                })
            ]
        });
    };
    return (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref4 = middleBodyState.media) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.background) === null || ref5 === void 0 ? void 0 : ref5.type) === "video" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(MiddleBodyVideoBackground, {
        id: "MT__MIDDLEBODY3",
        styleConfig: styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.config,
        themeBackground: propStyle === null || propStyle === void 0 ? void 0 : propStyle.backgroundColor,
        className: "modern_theme_middlebody3 bg_type_".concat(middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref6 = middleBodyState.media) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.background) === null || ref7 === void 0 ? void 0 : ref7.type),
        children: [
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                autoPlay: true,
                loop: true,
                muted: true,
                onError: function(e) {
                    var ref, ref1, ref2;
                    return e.target.src = (ref2 = middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref = middleBodyState.media) === null || ref === void 0 ? void 0 : (ref1 = ref.background) === null || ref1 === void 0 ? void 0 : ref1.content[0]) === null || ref2 === void 0 ? void 0 : ref2.url;
                },
                playsInline: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: (ref10 = middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref8 = middleBodyState.media) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.background) === null || ref9 === void 0 ? void 0 : ref9.content[0]) === null || ref10 === void 0 ? void 0 : ref10.url,
                    type: "video/mp4"
                })
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBodyParent, {
                id: "MT__MIDDLEBODY3",
                styleConfig: styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.config,
                propsBackground: middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref11 = middleBodyState.media) === null || ref11 === void 0 ? void 0 : ref11.background,
                themeBackground: propStyle === null || propStyle === void 0 ? void 0 : propStyle.backgroundColor,
                className: "modern_theme_middlebody3 bg_type_".concat(middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref12 = middleBodyState.media) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.background) === null || ref13 === void 0 ? void 0 : ref13.type),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerContainer, {
                    children: [
                        " ",
                        renderParentContainer("video"),
                        " "
                    ]
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(MiddleBodyParent, {
        id: "MT__MIDDLEBODY3",
        styleConfig: styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.config,
        propsBackground: middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref14 = middleBodyState.media) === null || ref14 === void 0 ? void 0 : ref14.background,
        themeBackground: propStyle === null || propStyle === void 0 ? void 0 : propStyle.backgroundColor,
        className: "modern_theme_middlebody3 bg_type_".concat(middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref15 = middleBodyState.media) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.background) === null || ref16 === void 0 ? void 0 : ref16.type),
        children: [
            (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref17 = middleBodyState.media) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.background) === null || ref18 === void 0 ? void 0 : ref18.type) === "image" && ((ref21 = middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref19 = middleBodyState.media) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.background) === null || ref20 === void 0 ? void 0 : ref20.content[0]) === null || ref21 === void 0 ? void 0 : ref21.url.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: "bg",
                src: (ref24 = middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref22 = middleBodyState.media) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.background) === null || ref23 === void 0 ? void 0 : ref23.content[0]) === null || ref24 === void 0 ? void 0 : ref24.url,
                onError: function(e) {
                    var ref, ref1, ref2;
                    return e.target.src = (ref2 = middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref = middleBodyState.media) === null || ref === void 0 ? void 0 : (ref1 = ref.background) === null || ref1 === void 0 ? void 0 : ref1.content[0]) === null || ref2 === void 0 ? void 0 : ref2.url;
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerContainer, {
                children: [
                    " ",
                    renderParentContainer("")
                ]
            })
        ]
    });
}
/* harmony default export */ var ModernMiddleBody3_ModernMiddleBody3 = (ModernMiddleBody3);


/***/ })

}]);